// extracted by mini-css-extract-plugin
export var searchHeader = "_6n-0";
export var searchHeaderDark = "_6n-1";